import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';

import {
  isProduction,
  theGraphBase,
  theGraphBaseBinance,
  theGraphBaseBinanceTest,
  theGraphBaseGoerli,
} from '../../../config';
import { getCurrentChainType } from '../../../lib';

export const NETWORKS_BY_CHAIN = {
  eth: ['MAINNET', 'RINKEBY', 'GOERLI'],
  bsc: ['BINANCE', 'BSCTEST'],
};

const createHttpLink = (uri: string) => new HttpLink({ uri });

const ethereumLink = createHttpLink(
  isProduction ? theGraphBase : theGraphBaseGoerli,
);
const binanceLink = createHttpLink(
  isProduction ? theGraphBaseBinance : theGraphBaseBinanceTest,
);

const createApolloClient = () => {
  const link = ApolloLink.split(
    operation => {
      const currentNetwork =
        operation.getContext().network ?? getCurrentChainType();

      return NETWORKS_BY_CHAIN.eth.includes(currentNetwork as string); // check is ethereum
    },
    ethereumLink,
    binanceLink,
  );

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};

export const apolloClientMultipleNetworks = createApolloClient();
